<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "OsobaBase"
};
</script>

<style scoped>

</style>
